import { useEffect, useState } from "react";
import { LOGO_URL, WHATSAPP_PASSENGERS_GROUP, COMPANY_NAME } from "../../lib/troy";
import { ExternalLink, Menu, X } from "lucide-react";

const NAV = [
  { label: "Início", href: "#inicio" },
  { label: "Pedir corrida", href: "#pedir-corrida" },
  { label: "Sobre", href: "#sobre" },
  { label: "Serviços", href: "#servicos" },
  { label: "Passageiros", href: "#passageiros" },
  { label: "Prêmios", href: "#premios" },
  { label: "Motoristas", href: "#motoristas" },
  { label: "Feedback", href: "#feedback" },
  { label: "Contato", href: "#contato" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-40 transition-all duration-300 ${
        scrolled
          ? "bg-black/75 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <a
          href="#inicio"
          data-testid="header-logo-link"
          className="flex items-center gap-3 group"
        >
          <img
            src={LOGO_URL}
            alt={`${COMPANY_NAME} logo`}
            className="logo-ring h-11 w-11 md:h-14 md:w-14 rounded-xl object-contain bg-black/80 backdrop-blur-md border border-[#FFCC00]/30 transition-transform duration-300 group-hover:scale-105"
          />
          <div className="flex flex-col leading-tight">
            <span className="font-display text-base md:text-lg font-black tracking-tight">
              TROY
            </span>
            <span className="text-[10px] md:text-xs uppercase tracking-[0.25em] text-[#FFCC00] font-semibold">
              Transportes
            </span>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-8" aria-label="Principal">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-${n.label.toLowerCase()}`}
              className="text-sm text-white/80 hover:text-[#FFCC00] transition-colors"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={WHATSAPP_PASSENGERS_GROUP}
            target="_blank"
            rel="noreferrer noopener"
            data-testid="header-whatsapp-cta"
            className="hidden sm:inline-flex items-center gap-2 bg-[#FFCC00] text-black font-bold text-sm px-5 py-2.5 rounded-full hover:bg-[#E6B800] transition-all transform hover:-translate-y-0.5 shadow-[0_0_24px_rgba(255,204,0,0.35)]"
          >
            <ExternalLink className="w-4 h-4" />
            Entrar no grupo
          </a>
          <button
            onClick={() => setOpen((v) => !v)}
            data-testid="mobile-menu-toggle"
            aria-label="Abrir menu"
            className="lg:hidden p-2 rounded-lg bg-white/5 border border-[#FFCC00]/15 text-white"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="mobile-nav"
          className="lg:hidden border-t border-white/10 bg-black/95 backdrop-blur-xl"
        >
          <div className="px-6 py-4 flex flex-col gap-3">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="py-2 text-white/90 hover:text-[#FFCC00]"
                data-testid={`mobile-nav-${n.label.toLowerCase()}`}
              >
                {n.label}
              </a>
            ))}
            <a
              href={WHATSAPP_PASSENGERS_GROUP}
              target="_blank"
              rel="noreferrer noopener"
              className="mt-2 inline-flex justify-center items-center gap-2 bg-[#FFCC00] text-black font-bold px-5 py-3 rounded-full"
              data-testid="mobile-whatsapp-cta"
            >
              <ExternalLink className="w-4 h-4" /> Entrar no grupo de passageiros
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
